import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import './App.css';
import './assets/styles/index.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Loading from './components/Loader/Loader';
import Loader2 from './components/Loader/Loader2';
import MainLayout from './components/MainLayout/MainLayout';
import { useDispatch, useSelector } from 'react-redux';
import { restoreLoginState,logout } from "./redux/slices/loginSlice";
import { useNavigate } from 'react-router-dom';

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { isLoggedIn, user, token } = useSelector(state => state.login);
  const navigate = useNavigate();
  // Check if user is logged in on component mount
  useEffect(() => {
    dispatch(restoreLoginState()); // Restore login state from cookies
  }, [dispatch]);
  const handleLogout = () => {
    dispatch(logout({ token }));
    navigate("/"); 
  }; 
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); 

    AOS.init({
      duration: 1200,
      once: false,
    });

    return () => clearTimeout(timer); 
  }, []);

  if (loading) {
    return <Loader2 />; 
  }
  
  return (
    <MainLayout isLoggedIn={isLoggedIn} onLogout={handleLogout} user={user}>
      <Outlet />
    </MainLayout>
  );
}

export default App;
